{
    "PLAIN-TEXT": {
        "IMPORT-CP": "import { CiaoPrologInterface } from '@ciao-lang/ts-ciao-interface';",
        "CIAO-CALL": "const res = await cp.ciao_query_begin(query);",
        "CIAO-GET-RESPONSE": "const res_cp = cp.ciao_mk_string(res.arg);"
    },
    "CIAO-TO-TS": {
        "number": "ciao_mk_flt",
        "string": "ciao_mk_string",
        "number[]": "ciao_mk_list"
    }
}